import React, {Component} from 'react';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {term: ''};
  }


  onInputChange(term) {
    this.setState({term});
    this.props.onSearchTermChange(term);
  }

  render() {
    return (
      <form className="search">
        <div className="field">
          <input className="input-search" type="text" id="input-search" onChange={event => this.onInputChange(event.target.value)}  required/>
          <label htmlFor="input-search">&nbsp;</label>
        </div>
      </form>
    )
  }
}

export default SearchBar;


// WEBPACK FOOTER //
// ./src/components/search_bar.js